import {
  FaCalendar, FaCalendarPlus, FaList, FaPlusCircle,
} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import AppState from '../store/appstate';
import { getMyAccount } from '../api/queries';
import { hasAdminRights } from '../auth/shared';

import SideNavItem from '../components/sideNavItem';

function GigsMenu() {
  const { t } = useTranslation();
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });
  const adminRights = hasAdminRights(myAccount?.data);

  return (
    <>
      <SideNavItem id="btnGigsMenuOverview" icon={<FaCalendar />} to="/gigs/" exact title={t('gigs:gigs-menu-overview')} subtitle={t('gigs:your-gigs-subheader')} />
      <SideNavItem id="btnGigsMenuClaim" icon={<FaCalendarPlus />} to={adminRights ? '/gigs/claim' : ''} exact title={t('gigs:gigs-menu-claim')} subtitle={t('gigs:gigs-menu-claim-subtitle')} disabled={!adminRights} />
      <SideNavItem id="btnGigsMenuSetlists" icon={<FaList />} to={adminRights ? '/gigs/setlists' : ''} exact title={t('gigs:gigs-menu-setlists')} subtitle={t('gigs:gigs-menu-setlists-subtitle')} disabled={!adminRights} />
      <SideNavItem id="btnGigsMenuCreate" icon={<FaPlusCircle />} to={adminRights ? '/gigs/setlists/create' : ''} title={t('gigs:gigs-menu-add-setlist')} subtitle={t('gigs:gigs-menu-add-setlist-subtitle')} disabled={!adminRights} />
    </>

  );
}
export default GigsMenu;
